<mat-drawer-container class="block w-full h-[var(--app-vh)]">
    <mat-drawer
        #accountDrawer
        [mode]="drawerMode"
        position="end"
        (closed)="closeDrawer()"
        [style.width]="drawerWidth"
    >
        <router-outlet name="drawer"></router-outlet>
    </mat-drawer>

    <!-- Loading bar -->
    <fuse-loading-bar></fuse-loading-bar>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full bg-solewa-white">
        <div
            class="mt-4 sm:mb-0 mb-[40px] sm:h-[100px] flex flex-row w-full sm:py-6 px-4 sm:px-16 justify-between t-4 sm:mt-0 items-center"
        >
            <img
                class="w-[96px] sm:w-[186px]"
                src="assets/images/logo/wewise.svg"
                alt="Logo image"
            />
            <button
                mat-button
                class="solewa-button-secondary h-[37px]"
                [routerLink]="[{ outlets: { drawer: ['account'] } }]"
            >
                Mon compte
            </button>
        </div>
        <!-- Content -->
        <div class="flex flex-col flex-auto relative overflow-hidden">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
            @if (true) {
            <div [@routeAnimations]="prepareRoute(outlet)">
                <router-outlet #outlet="outlet"></router-outlet>
            </div>
            }
        </div>
    </div>
</mat-drawer-container>
